import {Subject} from 'rxjs'
import selector, {identitySelector} from 'utils/selector'

export type PublisherEventType = 'problemUpdated' | 'problemArchived'

export default class DispatchService {
  private subject = new Subject<{type: PublisherEventType; payload: any}>()

  public observe = <T = any>(type: PublisherEventType) => {
    return this.subject
      .asObservable()
      .filter((e) => e.type === type)
      .map((e) => e.payload as T)
  }

  public dispatch = <T = any>(type: PublisherEventType, payload: T) => {
    this.subject.next({type, payload})
  }
}

export const dispatchServiceSelector = selector(identitySelector<null>(), () => new DispatchService())
